var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "highlight_off_black_18dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.28,
    height: 28.28,
    viewBox: "0 0 28.28 28.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17204",
    "data-name": "Path 17204",
    d: "M0,0H28.28V28.28H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17205",
    "data-name": "Path 17205",
    d: "M17.284,9.284,14.14,12.428,11,9.284,9.284,11l3.144,3.144L9.284,17.284,11,19l3.144-3.144L17.284,19,19,17.284,15.852,14.14,19,11ZM14.14,2A12.14,12.14,0,1,0,26.28,14.14,12.129,12.129,0,0,0,14.14,2Zm0,21.852a9.712,9.712,0,1,1,9.712-9.712A9.725,9.725,0,0,1,14.14,23.852Z",
    fill: "#e10a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconRed);
export default __webpack_public_path__ + "static/media/cross-icon-red.2068765fa5feebb65f6c74b3b5c02995.svg";
export { ForwardRef as ReactComponent };